// Module
var code = "<template class=\"a-checkbox\"> <require from=\"components/field/common/base-checkbox/base-checkbox\"></require> <base-checkbox name.bind=\"fieldId\" checked.bind=\"checked\" label.bind=\"label\" disabled.bind=\"disabled\" model.bind=\"model\"></base-checkbox> </template> ";
// Exports
export default code;